export default "__VITE_ASSET__bf4d8ec9__"